import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Env from '../services/Env'

if (Env.GOOGLE_ANALYTICS_ID) {
  Vue.use(VueAnalytics, {
    id: Env.GOOGLE_ANALYTICS_ID,
    autoTracking: {
      screenview: false,
      pageviewOnLoad: false,
    },
  })
}
